const BASE_URL = process.env.REACT_APP_BASE_URL;
const BASE_URL_ECOM = process.env.REACT_APP_BASE_URL_ECOM;

const apiUrl = {
    common: {
        getAllMeta: `${BASE_URL}/v1/page-meta-tag/all`,
    },
    banner: {
        getActive: `${BASE_URL}/v1/banner/active`,
        getByType: (type) => `${BASE_URL}/v1/banner/type/${type}`,
    },
    auth: {
        login: `${BASE_URL_ECOM}/auth/sign-in`,
        register: `${BASE_URL_ECOM}/auth/sign-up`,
        guestRegister: `${BASE_URL_ECOM}/auth/guest-sign-up`,
        refreshToken: `${BASE_URL_ECOM}/auth/refresh`,
        guestToken: `${BASE_URL_ECOM}/auth/guest-token`,
        forgotPassword: `${BASE_URL_ECOM}/auth/forgot-password`,
        resetPassword: `${BASE_URL_ECOM}/auth/reset-password`,
        // logout: `${BASE_URL}/v1/auth/logout`
    },
    collection: {
        getAll: `${BASE_URL}/v1/collection/all`,
        getMaterialsById: (collectionId) => `${BASE_URL}/v1/collection/get-materials/${collectionId}`,
        getMaterials: (slug) => `${BASE_URL}/v1/collection/get-slug/${slug}`,
        getMaterialsBySlug: (slug) => `${BASE_URL}/v1/material/by-slug/${slug}`,
        getTrending: `${BASE_URL}/v1/collection/trending`
    },
    franchiseEnquiry: `${BASE_URL}/v1/util/franchise-enquiry`,
    store: `${BASE_URL}/v1/store/get-all`,
    search: (searchTerm) => `${BASE_URL}/v1/util/search?q=${searchTerm}`,
    inspiredLiving: (articleType) => `${BASE_URL}/v1/article/by-type?type=${articleType}`,
    inspiredLivingSearch: (articleType, searchTerm) => `${BASE_URL}/v1/article/search?type=${articleType}&q=${searchTerm}`,
    // ecom
    shop: {
        getAllSKUs: (pageNo, pageSize, direction, orderBy, categoryName, filters) => {
            const safeFilters = filters || {};
            const category = safeFilters.category || [];
            const collectionName = safeFilters.collectionName || [];
            const size = safeFilters.size || [];
            const designs = safeFilters.designs || [];
            const fabrics = safeFilters.fabrics || [];
            const threadCounts = safeFilters.threadCounts || [];
            const packagingTypes = safeFilters.packagingTypes || [];
            const priceRange = safeFilters.priceRange || [0, 25000];
            
            return `${BASE_URL_ECOM}/sku/filter?page=${pageNo}&pageSize=${pageSize}&direction=${direction}&orderBy=${orderBy}&categoryName=${category.length > 0 ? category.join(',') : categoryName || ''}&collectionName=${collectionName.length > 0 ? collectionName.join(',') : ''}&size=${size.length > 0 ? size.join(',') : ''}&design=${designs.length > 0 ? designs.join(',') : ''}&fabType=${fabrics.length > 0 ? fabrics.join(',') : ''}&packagingType=${packagingTypes.length > 0 ? packagingTypes.join(',') : ''}&minPrice=${priceRange[0] || 0}&maxPrice=${priceRange[1] || 25000}&threadCount=${threadCounts.length > 0 ? threadCounts.join(',') : ''}`;
        },
        getAllTimeFav: `${BASE_URL_ECOM}/sku/all-time-favorite`,
        getCollectionsList: `${BASE_URL_ECOM}/collection/get-list`,
        getCategoryList: `${BASE_URL_ECOM}/category/get-list`,
        getFilterOptions: `${BASE_URL_ECOM}/sku/filter-option`,
        search: (searchTerm, page, pageSize) => `${BASE_URL_ECOM}/sku/search?q=${searchTerm}&page=${page}&pageSize=${pageSize}`,
    },
    product: {
        getSKUDetailsBySlug: (slug) => `${BASE_URL_ECOM}/sku/by-slug/${slug}`,
        getSKUDetails: (skuId) => `${BASE_URL_ECOM}/sku/get-by-id?id=${skuId}`,
        getCollectionDetails: (collectionId) => `${BASE_URL_ECOM}/collection/get-detail?id=${collectionId}`,
        getCategoryDetails: (categoryId) => `${BASE_URL_ECOM}/category/get-detail?id=${categoryId}`,
        getFeaturedProducts: `${BASE_URL_ECOM}/sku/feature-product`,
        getMakeItSet: (id) => `${BASE_URL_ECOM}/sku/make-it-set?id=${id}`,
        getUpgradeSleepSet: (id) => `${BASE_URL_ECOM}/sku/upgrade-sleep?id=${id}`,
        getYouMayLike: (id) => `${BASE_URL_ECOM}/sku/you-may-like?id=${id}`,
    },
    cart: {
        getCart: `${BASE_URL_ECOM}/cart/get-cart`,
        updateCart: `${BASE_URL_ECOM}/cart/add-cart`,
        applyRemoveCouponCart: (coupon) => `${BASE_URL_ECOM}/cart/apply-coupon/${coupon}`,
        cartCheckout: `${BASE_URL_ECOM}/cart/order`,
        getWishlist: `${BASE_URL_ECOM}/user/wishlist`,
        addRemoveFromWishlist: (skuId) => `${BASE_URL_ECOM}/user/wishlist/${skuId}`,
        getCouponList: `${BASE_URL_ECOM}/cart/coupons`,
        paymentVerification: `${BASE_URL_ECOM}/cart/verifyPayment`,
        paymentfailed: `${BASE_URL_ECOM}/cart/payment-failed`,
        deliveryStatus: (pinCode) => `${BASE_URL_ECOM}/cart/check-delivery-pincode/${pinCode}`,
        otpSent: `${BASE_URL_ECOM}/cart/cod-otp`,
        resendOtp: `${BASE_URL_ECOM}/cart/cod-resend-otp`,
        cartToken: (token) => `${BASE_URL_ECOM}/cart/verify-cart-token/${token}`,
        retryPayment: (orderId) => `${BASE_URL_ECOM}/cart/retry-payment/${orderId}`,
    },
    address: {
        getAddAddress: `${BASE_URL_ECOM}/user/address`,
        updateAddress: (addressId) => `${BASE_URL_ECOM}/user/address/${addressId}`,
        deleteAddress: (addressId) => `${BASE_URL_ECOM}/user/address/${addressId}`,
        makeAddDefault: (addressId) => `${BASE_URL_ECOM}/user/address/default/${addressId}`,
    },
    profile: {
        getProfile: `${BASE_URL_ECOM}/user/profile`,
        updateProfile: `${BASE_URL_ECOM}/user/profile`
    },
    orderDetails: {
        getOrderDetails: `${BASE_URL_ECOM}/user/order/my-orders`,
    },
    job: {
        getAll: `${BASE_URL}/v1/job/get-all`,
        getById: (jobId) => `${BASE_URL}/v1/job/by-id/${jobId}`,
    }
};

export default apiUrl;